import { Box, DropdownButton, DropdownMenu, Flex, Icon, IconicButton, Input, Text } from "@nulogy/components";
import React from "react";
import styled, { useTheme } from "styled-components";

const Border = styled(Flex)(({ theme }) => ({
  "&:focus-within": {
    borderColor: theme.colors.blue,
    boxShadow: `0 0 5px 0 ${theme.colors.blue}E6`,
  },
  "&:has(.nds-popper-pop-up)": {
    borderRadius: `${theme.sizes.half} ${theme.sizes.half} 0 0`,
  },
  alignItems: "center",
  border: `1px solid ${theme.colors.lightGrey}`,
  borderRadius: theme.sizes.half,
  marginBottom: theme.space.x2,
}));

const BorderlessInput = styled(Input)(({ theme }) => ({
  color: theme.colors.black,
  input: {
    border: "none",
    padding: "0px",
    width: "100%",
  },

  "input:focus": {
    border: "none",
    boxShadow: "none",
  },
}));

const DropdownMenuWrapper = styled.div(({ theme }) => ({
  ".nds-popper-pop-up": {
    border: `1px ${theme.colors.blue} solid`,
    borderRadius: `0 0 ${theme.sizes.half} ${theme.sizes.half}`,
    boxShadow: `0 0 5px 0 ${theme.colors.blue}E6`,
    padding: theme.space.none,
  },
}));

const VerticalDivider = styled(Box)(({ theme }) => ({
  borderLeft: `1px solid ${theme.colors.grey}`,
  height: "24px",
}));

export default function WorkOrderSearch({
  searchCategoryOptions,
  searchCategory,
  searchText,
  onTextSearch,
  onCategoryChange,
}) {
  const searchCategoryName = searchCategoryOptions.find((option) => option.value === searchCategory)?.label;
  const theme = useTheme();

  const changeSearchText = (newSearchText) => {
    onTextSearch({ searchCategory, searchText: newSearchText });
  };

  const changeSearchCategory = (newSearchCategory) => {
    onCategoryChange({ searchCategory: newSearchCategory, searchText });
  };

  const handleWorkOrderSearch = (event) => {
    const newSearchText = event?.target?.value;
    if (newSearchText === searchText) return;

    changeSearchText(newSearchText);
  };

  const clearSearch = () => {
    onCategoryChange({ searchCategory: "", searchText: "" });
  };

  return (
    <Border>
      <Icon
        fill={theme.colors.midGrey}
        focusable="false"
        height="24px"
        icon="search"
        margin={theme.space.half}
        width="24px"
      />
      {searchCategoryName && (
        <Text color={theme.colors.midGrey} whiteSpace="nowrap">
          {searchCategoryName}:
        </Text>
      )}
      <BorderlessInput
        className="spec-filter-field searchFilterInput pendo-search-filter"
        onChange={handleWorkOrderSearch}
        placeholder={searchCategoryName ? "" : "Search work orders..."}
        value={searchText}
      />
      <Flex gap={theme.space.half} style={{ alignItems: "center" }}>
        {(searchText || searchCategoryName) && (
          <IconicButton color={theme.colors.midGrey} icon="close" onClick={clearSearch} />
        )}
        {(searchText || searchCategoryName) && <VerticalDivider />}
        <DropdownMenuWrapper>
          <DropdownMenu
            maxHeight="240px"
            overflowY="auto"
            placement="bottom-end"
            showArrow={false}
            trigger={() => (
              <Box>
                <IconicButton
                  color={theme.colors.midGrey}
                  data-testid="search-options-trigger"
                  icon="tune"
                  marginRight={theme.space.half}
                  tooltip="Show search options"
                />
              </Box>
            )}
            width="calc(100% - 32px)"
          >
            {searchCategoryOptions.map((option) => (
              <DropdownButton
                color={theme.colors.black}
                data-testid={`search-category-option-${option.value}`}
                fontWeight={theme.fontWeights.normal}
                key={option.value}
                onClick={() => {
                  changeSearchCategory(option.value);
                }}
              >
                {option.label}
              </DropdownButton>
            ))}
          </DropdownMenu>
        </DropdownMenuWrapper>
      </Flex>
    </Border>
  );
}
